import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { showAccessDeniedAlert } from "../../../utils/accessDenied"
import RoutesMap from "../../../route_control/RouteControl"
import axios from "axios"

export const participantList = createAsyncThunk('participantList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `unfollowed_participant_list`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('user_token'),
            }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const participantListSlice = createSlice({
    name: 'participantList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(participantList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                localStorage.clear()
                action.meta.arg.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(participantList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default participantListSlice.reducer; 